/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();


document.addEventListener("DOMContentLoaded", function() {
    const currentUrl = window.location.pathname;

    // Match exact product within collection URL
   
      if ( currentUrl.includes('/products/customize-your-barrel-saddle')) {
      window.location.href = '/products/barrel-saddle-customized';
    }
   
         if (  currentUrl.includes('/products/customize-your-calf-roper-saddle')) {
      window.location.href = '/products/calf-saddle-customized';
    }
    
        if ( currentUrl.includes('/products/customize-your-breakaway-saddle')) {
      window.location.href = '/products/breakaway-saddle-customized';
    }
     
        if (currentUrl.includes('/products/customize-your-ranch-saddle')) {
      window.location.href = '/products/testing-four';
    }
     if (currentUrl.includes('/products/customize-your-in-seat-rigging-saddle')) {
      window.location.href = '/pages/custom-saddle';
    }
    if (currentUrl.includes('/products/customize-your-youth-kids-saddle')) {
      window.location.href = '/pages/custom-saddle';
    }
   if (currentUrl.includes('/products/customize-your-wade-saddle')) {
      window.location.href = '/products/wade-saddle-customized';
    }
     if (currentUrl.includes('/products/customize-your-lady-saddle')) {
      window.location.href = '/pages/custom-saddle';
    }
     if (currentUrl.includes('/products/customize-your-cutting-saddle')) {
      window.location.href = '/products/real-cutter-customized';
    }
if (currentUrl.includes('/products/customize-your-beartrap-saddle')) {
      window.location.href = '/products/beartrap-customized';
    }
if (currentUrl.includes('/products/customize-your-steer-wrestler-saddle')) {
      window.location.href = '/products/steer-wrestler-saddle-customized';
    }
    if (currentUrl.includes('/products/customize-your-reining-saddle')) {
      window.location.href = '/products/copy-of-beartrap-customized';
    }
  if (currentUrl.includes('/products/customize-your-roper-saddle')) {
      window.location.href = '/products/roper-saddle-customized';
    }
    
  });
